export default __webpack_public_path__ + "static/media/search-image.26d77b9a.svg";